import React from "react";
import { MenuItem } from "@blueprintjs/core";
import { MultiSelect } from "@blueprintjs/select";

type ItemType = { value: string; label: string };

interface CustomMultiSelectProps {
  items: ItemType[];
  values: string[];
  onSelect: (item: ItemType) => void;
  onRemove: (value: React.ReactNode) => void;
  customTarget?: ((selectedItems: ItemType[]) => React.ReactNode) | undefined;
	className?: string;
}

const CustomMultiSelect: React.FC<CustomMultiSelectProps> = ({
  items,
  values,
  onSelect,
  onRemove,
  customTarget,
	className
}) => {
  return (
    <MultiSelect
      activeItem={null}
      
      customTarget={customTarget}
      items={items}
      onItemSelect={(item, event) => {
        if (event) event.stopPropagation();
        onSelect(item);
      }}
      tagRenderer={(item) => item.label}
      itemPredicate={(query, item) =>
        item.label.toLowerCase().includes(query.toLowerCase()) ||
        item.value.toLowerCase().includes(query.toLowerCase())
      }
      itemRenderer={(item, { modifiers, handleClick }) => (
        <MenuItem
          active={modifiers.active}
          text={item.label}
          icon={values.includes(item.value) ? "tick" : "blank"}
          key={item.value}
          onClick={handleClick}
        />
      )}
      selectedItems={items.filter((item) => values.includes(item.value))}
      tagInputProps={{
        onRemove: (_value: React.ReactNode) => {
          onRemove(_value);
        },
        tagProps: { intent: "primary", minimal: true },
        className: "limit-tag-height",
        placeholder: values.length === 0 ? "Select..." : "",
        fill: true
      }}
      
      popoverProps={{matchTargetWidth:true, minimal: true, popoverClassName: "limit-popover-height" }}
			className={className}
    />
  );
};

export default CustomMultiSelect;
